<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        method="postJson"
        url="sapProductionOrderDetails/selectPage"
        @reset="resetHandle"
        @select="selectHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="65px" @keyup.enter.native="loadData(1)">
            <el-form-item label="生产订单">
              <el-input v-model.trim="filter.iT" placeholder="请输入生产订单" clearable/>
            </el-form-item>
            <el-form-item label="组件物料">
              <el-input v-model.trim="filter.materialCode" placeholder="请输入物料号" clearable/>
            </el-form-item>
            <el-form-item label="组件规格" style="size: 50px">
              <el-input v-model.trim="filter.specification" placeholder="请输入组件规格型号" clearable/>
            </el-form-item>
            <el-form-item label="工单物料">
              <el-input v-model.trim="filter.orderMaterialNo" placeholder="请输入工单物料" clearable/>
            </el-form-item>
            <el-form-item label="工单规格">
              <el-input v-model.trim="filter.orderSpecification" placeholder="请输入工单规格型号" clearable/>
            </el-form-item>
            <el-form-item label="库位">
              <el-input v-model.trim="filter.positionNo" placeholder="请输入库位" clearable/>
            </el-form-item>
            <el-form-item label="发料状态">
              <el-select v-model="filter.productOrderFeedingStatus" clearable>
                <el-option label="全部" :value="-1"/>
                <el-option label="待发料" :value="0"/>
                <el-option label="部分发料" :value="10"/>
                <el-option label="全部发料" :value="20"/>
              </el-select>
            </el-form-item>
            <el-form-item label="报工状态">
              <el-select v-model="filter.confirmStatus" clearable>
                <el-option label="全部" :value="-1"/>
                <el-option label="未报工" :value="0"/>
                <el-option label="部分报工" :value="1"/>
                <el-option label="全部报工" :value="2"/>
              </el-select>
            </el-form-item>
            <el-form-item label="不含类型">
              <el-select v-model="filter.materialTypeList" clearable multiple>
                <el-option label="文本" :value="'文本'"/>
                <el-option label="反冲" :value="'反冲'"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.deliveryAuth" type="success" @click="postProduction(scope.row)">
          发料
        </el-button>
      </template>
    </view-table>
    <production-post ref="productionPost" @save-success="loadData"/>
    <dispatch-detail ref="dispatchDetail" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import ProductionPost from "@/views/ProductionManagement/ProductionOrder/ProductionPost";
  import DispatchDetail from "./DispatchDetail.vue";

  export default {
    name: "ProductionOrderDetailList",
    components: {ViewTable,ProductionPost,DispatchDetail},
    data() {
      return {
        options: [],
        limits: {
          deliveryAuth: this.$auth(468),
        },
        filter: {
          iT:"",
          materialCode:"",
          specification:"",
          orderMaterialNo:"",
          orderSpecification:"",
          positionNo:"",
          productOrderFeedingStatus:-1,
          materialTypeList:["文本","反冲"],
          confirmStatus:-1,
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "it",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.dispatchDetail.open(params.row.mastPKID, true);
                    },
                  },
                },
                params.row.it,
              );
            },
          },
          {
            key: "action",
            width: 250,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },


      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.salesOrderEdit.open(row);
      },

      //未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.demandStatus !== "Y") {
          return  false;
        } else {
          return  true;
        }
      },
      postProduction(row) {
        this.$refs.productionPost.open(row.it);
      },

    },
  };
</script>
